<app-org-appbar></app-org-appbar>
<br />
<kendo-tilelayout
  [columns]="2"
  rowHeight=""
  [resizable]="true"
  [reorderable]="true"
>
  <kendo-tilelayout-item
    [col]="1"
    [colSpan]="2"
    [rowSpan]="2"
  >
    <kendo-tilelayout-item-header class="org-details-header d-flex justify-content-between align-items-center">
      <h4>Overview</h4>
      <div class="ms-auto">
        <button
          kendoButton
          class="details-edit-button"
          [id]="
            isReadOnlyGeneral()
              ? 'admin_organizations_general_overview_edit'
              : 'admin_organizations_general_overview_save'
          "
          (click)="onButtonClickGeneral()"
        >
          {{ isReadOnlyGeneral() ? 'Edit' : 'Save' }}
        </button>
      </div>
    </kendo-tilelayout-item-header>
    @if (isLoading()) {
      <kendo-loader
        [type]="'infinite-spinner'"
        [size]="'large'"
      ></kendo-loader>
    } @else {
      <kendo-tilelayout-item-body>
        <div class="example">
          <form
            class="orgForm"
            [formGroup]="orgForm()"
          >
            <kendo-formfield>
              <kendo-label
                labelCssClass="k-form-label"
                text="Organization ID"
              ></kendo-label>
              <kendo-textbox formControlName="id"></kendo-textbox>
            </kendo-formfield>
            <kendo-formfield>
              <kendo-label
                labelCssClass="k-form-label"
                text="Name"
              ></kendo-label>
              <kendo-textbox formControlName="name"></kendo-textbox>
            </kendo-formfield>
            <kendo-formfield>
              <kendo-label
                labelCssClass="k-form-label"
                text="Owner"
              ></kendo-label>
              <kendo-textbox formControlName="owner"></kendo-textbox>
            </kendo-formfield>
            <kendo-formfield>
              <kendo-label
                labelCssClass="k-form-label"
                text="Owner Email"
              ></kendo-label>
              <kendo-textbox
                formControlName="owner_email"
                #email
              ></kendo-textbox>
            </kendo-formfield>
            <kendo-formfield>
              <kendo-label
                labelCssClass="k-form-label"
                text="Plan"
              ></kendo-label>
              <kendo-dropdownlist
                formControlName="account_type"
                [defaultItem]="{ text: 'Select Account Type', value: null }"
                [data]="accountTypeItems()"
                [valuePrimitive]="true"
                textField="display_text"
                valueField="id"
              ></kendo-dropdownlist>
            </kendo-formfield>
          </form>
          <form
            class="orgForm"
            [formGroup]="orgForm()"
          >
            <kendo-formfield>
              <kendo-label
                labelCssClass="k-form-label"
                text="Created"
              ></kendo-label>
              <kendo-textbox formControlName="created_at"></kendo-textbox>
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label
                labelCssClass="k-form-label"
                text="Website"
              ></kendo-label>
              <kendo-textbox formControlName="website"></kendo-textbox>
            </kendo-formfield>

            <kendo-label
              labelCssClass="k-form-label"
              text="Status"
            ></kendo-label>
            <kendo-dropdownlist
              formControlName="status"
              [defaultItem]="{ text: 'Select Status', value: null }"
              [valuePrimitive]="true"
              textField="text"
              valueField="value"
              [data]="[
                { text: 'Active', value: 1 },
                { text: 'Disabled', value: 0 }
              ]"
            ></kendo-dropdownlist>

            <div class="k-form-field">
              <kendo-label
                labelCssClass="k-form-label"
                text="Parent Organization"
              ></kendo-label>
              <cyflare-autocomplete
                [baseUrl]="'v1/organization/administrative/organizationautocomplete/'"
                [textField]="'display_text'"
                [valueField]="'id'"
                [placeholder]="'Search parent organization...'"
                [showDropdown]="true"
                [completeOnFocus]="false"
                [cacheTtlMs]="2000000"
                [pageSize]="100"
                [lazyScroll]="true"
                [formGroup]="orgForm()"
                [formValueFieldName]="'parentId'"
                [defaultItem]="orgDefaultItem"
                [selectedIds]="orgDefaultItem?.id?.toString() || ''"
              ></cyflare-autocomplete>
            </div>
            <kendo-formfield>
              <kendo-label
                labelCssClass="k-form-label"
                for="industry"
                text="Industry"
              ></kendo-label>
              <div>
                <kendo-dropdownlist
                  formControlName="industry"
                  [data]="industryItems()"
                  [defaultItem]="{ text: 'Select Industry', value: null }"
                  [valuePrimitive]="true"
                  textField="display_text"
                  valueField="id"
                ></kendo-dropdownlist>
              </div>
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label
                labelCssClass="k-form-label"
                for="billing_basis"
                text="Billing Basis"
              ></kendo-label>
              <div>
                <kendo-dropdownlist
                  formControlName="billing_basis"
                  [data]="billingBasisOptions"
                  [defaultItem]="billingBasisInheritItem"
                  [valuePrimitive]="true"
                  textField="label"
                  valueField="value"
                ></kendo-dropdownlist>
              </div>
              <kendo-formhint>How this org's billing-week count is chosen. Set at the partner level, override per sub-customer.</kendo-formhint>
              @if (billingBasisHint()) {
                <div class="billing-basis-hint">{{ billingBasisHint() }}</div>
              }
            </kendo-formfield>
          </form>
        </div>

        <form
          class="org-flags"
          [formGroup]="orgForm()"
        >
          <div class="org-flags-title">Flags</div>
          <div class="org-flags-grid">
            <div class="flag-item">
              <div class="flag-copy">
                <div class="flag-label">Demo Organization</div>
                <div class="flag-description">Non-production account; excluded from reporting</div>
              </div>
              <kendo-switch
                formControlName="is_demo_org"
                [onLabel]="'Yes'"
                [offLabel]="'No'"
              ></kendo-switch>
            </div>

            <div class="flag-item">
              <div class="flag-copy">
                <div class="flag-label">US Only</div>
                <div class="flag-description">Restrict data residency to the United States</div>
              </div>
              <kendo-switch
                formControlName="us_only"
                [onLabel]="'Yes'"
                [offLabel]="'No'"
              ></kendo-switch>
            </div>

            <div class="flag-item">
              <div class="flag-copy">
                <div class="flag-label">NFR</div>
                <div class="flag-description">Not For Resale &mdash; billing suppressed</div>
              </div>
              <kendo-switch
                formControlName="nfr"
                [onLabel]="'On'"
                [offLabel]="'Off'"
              ></kendo-switch>
            </div>

            <div class="flag-item">
              <div class="flag-copy">
                <div class="flag-label">Premium SLA</div>
                <div class="flag-description">Higher-tier response and escalation targets</div>
              </div>
              <kendo-switch
                formControlName="premium_sla"
                [onLabel]="'On'"
                [offLabel]="'Off'"
              ></kendo-switch>
            </div>

            <!-- Visibility of both controls is decided by the backend (alert_sync_controls). -->
            @if (alertSyncControls().propagate_to_children) {
              <div class="flag-item">
                <div class="flag-copy">
                  <div class="flag-label">Propagate alert preferences to children</div>
                  <div class="flag-description">
                    Copies this org's alert preferences to its direct child organizations on creation and whenever they change.
                  </div>
                </div>
                <kendo-switch
                  formControlName="propagate_alert_preferences_to_children"
                  [onLabel]="'On'"
                  [offLabel]="'Off'"
                ></kendo-switch>
              </div>
            }

            @if (alertSyncControls().stop_parent_sync) {
              <div class="flag-item">
                <div class="flag-copy">
                  <div class="flag-label">Stop parent synchronization</div>
                  <div class="flag-description">Refuses incoming alert-preference propagation from the parent.</div>
                </div>
                <kendo-switch
                  formControlName="stop_parent_synchronization"
                  [onLabel]="'On'"
                  [offLabel]="'Off'"
                ></kendo-switch>
              </div>
            }
          </div>
        </form>
      </kendo-tilelayout-item-body>
    }
  </kendo-tilelayout-item>

  @if (isMspOrMmsp()) {
    <kendo-tilelayout-item
      [col]="1"
      [colSpan]="2"
    >
      <kendo-tilelayout-item-header class="org-details-header d-flex justify-content-between align-items-center">
        <h4>Current Month Minimum Commit</h4>
      </kendo-tilelayout-item-header>
      <kendo-tilelayout-item-body>
        <app-metric-card
          [title]="minimumCommit() ? minimumCommit()!.month_label + ' Floor' : 'Current Month Floor'"
          [currentValue]="minimumCommit() ? ('$' + (minimumCommit()!.floor_amount | number: '1.0-0')) : '—'"
          [hideComparison]="true"
          [hidePrevious]="true"
          [showLeftBorder]="true"
          [leftBorderColor]="'var(--bootstrap-primary)'"
          [isLoading]="isMinimumCommitLoading()"
          [showLastUpdated]="!!minimumCommit()?.last_updated"
          [lastUpdatedDate]="minimumCommit()?.last_updated ?? null"
        ></app-metric-card>
      </kendo-tilelayout-item-body>
    </kendo-tilelayout-item>
  }
  <!-- <kendo-tilelayout-item
    [col]="1"
    [colSpan]="2"
    [rowSpan]="2"
  >
    <kendo-tilelayout-item-header class="org-details-header d-flex justify-content-between align-items-center">
      <h4>Subscriptions</h4>
      <div class="ms-auto">
        <button
          kendoButton
          class="details-edit-button"
          [id]="isReadOnlyGeneral() ? 'admin_organizations_general_overview_edit' : 'admin_organizations_general_overview_save'"
          (click)="onButtonClickGeneral()"
        >
          {{ isReadOnlyGeneral() ? 'Edit' : 'Save' }}
        </button>
      </div>
    </kendo-tilelayout-item-header>
    @if (isLoading()) {
      <kendo-loader
        [type]="'infinite-spinner'"
        [size]="'large'"
      ></kendo-loader>
    } @else {
      <kendo-tilelayout-item-body>
        <app-subscriptions></app-subscriptions>
      </kendo-tilelayout-item-body>
    }
  </kendo-tilelayout-item> -->
  @if (isAdmin === true) {
    <kendo-tilelayout-item
      [col]="1"
      [colSpan]="2"
    >
      <kendo-tilelayout-item-header class="org-details-header d-flex justify-content-between align-items-center">
        <h4>Users</h4>
        <div class="ms-auto col-md-2">
          <kendo-dropdownlist
            #userDropDownList
            [data]="availableUsersFiltered()"
            [defaultItem]="{ id: 0, first_name: 'Select user...' }"
            [valuePrimitive]="false"
            textField="first_name"
            valueField="id"
            (valueChange)="onUserAssigned($event)"
            (filterChange)="onUserDropDownFilterChange($event)"
            [filterable]="true"
            (open)="onUserDropDownOpen($event)"
          >
            <ng-template
              kendoDropDownListItemTemplate
              let-dataItem
            >
              {{ dataItem.first_name }} {{ dataItem.last_name }}
            </ng-template>
            <ng-template
              kendoDropDownListValueTemplate
              let-dataItem
            >
              {{ dataItem.first_name }} {{ dataItem.last_name }}
            </ng-template>
          </kendo-dropdownlist>
        </div>
      </kendo-tilelayout-item-header>
      @if (isLoading()) {
        <kendo-loader
          [type]="'infinite-spinner'"
          [size]="'large'"
        ></kendo-loader>
      } @else {
        <kendo-tilelayout-item-body class="flex-body">
          @for (user of users(); track $index) {
            <div class="contact">
              <div class="k-hstack">
                <kendo-avatar [initials]="user.email!"></kendo-avatar>
                <div>
                  <h5>{{ user.first_name }} {{ user.last_name }}</h5>
                  <p>{{ user.email }}</p>
                  <p>{{ user.groups }}</p>
                </div>
                <div style="display: flex; justify-content: start">
                  <kendo-dropdownbutton
                    [data]="['Remove User']"
                    (itemClick)="removeUser(user.id!, this.id())"
                    style="
                      position: absolute;
                      top: 0;
                      right: 0;
                      width: 40px;
                      height: 40px;
                      background-color: transparent;
                      border: none;
                      color: #000;
                      font-size: 1.5rem;
                      cursor: pointer;
                      display: flex;
                      align-items: flex-start;
                      justify-content: center;
                      padding: 0;
                    "
                  >
                    ...
                  </kendo-dropdownbutton>
                </div>
              </div>
            </div>
          }
        </kendo-tilelayout-item-body>
      }
    </kendo-tilelayout-item>
  } @else {}

  <!-- mXDR Details -->

  <kendo-tilelayout-item [col]="2">
    <kendo-tilelayout-item-header class="org-details-header d-flex justify-content-between align-items-center">
      <h4>mXDR Details</h4>
      <div class="ms-auto">
        <button
          kendoButton
          class="details-edit-button"
          [id]="isReadOnlyMxdr() ? 'admin_organizations_general_mxdr_edit' : 'admin_organizations_general_mxdr_save'"
          (click)="onButtonClickMxdr()"
        >
          {{ isReadOnlyMxdr() ? 'Edit' : 'Save' }}
        </button>
      </div>
    </kendo-tilelayout-item-header>
    @if (isLoading()) {
      <kendo-loader
        [type]="'infinite-spinner'"
        [size]="'large'"
      ></kendo-loader>
    } @else {
      <kendo-tilelayout-item-body class="max-width">
        <form
          class="k-form"
          [formGroup]="ckbForm()"
        >
          <kendo-label text="# of Windows Agents">
            <kendo-textbox formControlName="xdr_windows_agents"></kendo-textbox>
          </kendo-label>
          <kendo-label text="# of Linux Agents">
            <kendo-textbox formControlName="xdr_linux_agents"></kendo-textbox>
          </kendo-label>
          <kendo-label text="# of SysLog Senders">
            <kendo-textbox formControlName="xdr_syslog_senders"></kendo-textbox>
          </kendo-label>
          <kendo-label text="# of Network Sensors">
            <kendo-textbox formControlName="xdr_network_sensors"></kendo-textbox>
          </kendo-label>
          <kendo-label text="# of API Connectors">
            <kendo-textbox formControlName="xdr_api_connectors"></kendo-textbox>
          </kendo-label>
        </form>
      </kendo-tilelayout-item-body>
    }
  </kendo-tilelayout-item>

  <!--mEDR Details-->

  <kendo-tilelayout-item [col]="1">
    <kendo-tilelayout-item-header class="org-details-header d-flex justify-content-between align-items-center">
      <h4>mEDR Details</h4>
      <div class="ms-auto">
        <button
          kendoButton
          class="details-edit-button"
          [id]="isReadOnlyMedr() ? 'admin_organizations_general_medr_edit' : 'admin_organizations_general_medr_save'"
          (click)="onButtonClickMedr()"
        >
          {{ isReadOnlyMedr() ? 'Edit' : 'Save' }}
        </button>
      </div>
    </kendo-tilelayout-item-header>
    @if (isLoading()) {
      <kendo-loader
        [type]="'infinite-spinner'"
        [size]="'large'"
      ></kendo-loader>
    } @else {
      <kendo-tilelayout-item-body class="max-width">
        <form
          class="k-form"
          [formGroup]="ckbForm()"
        >
          <kendo-label text="# of Windows Asset">
            <kendo-textbox formControlName="mdr_windows"></kendo-textbox>
          </kendo-label>
          <kendo-label text="# of Linux Asset">
            <kendo-textbox formControlName="mdr_linux"></kendo-textbox>
          </kendo-label>
          <kendo-label text="# of Mac Asset">
            <kendo-textbox formControlName="mdr_mac"></kendo-textbox>
          </kendo-label>
        </form>
      </kendo-tilelayout-item-body>
    }
  </kendo-tilelayout-item>

  <!-- Account Mappings -->
  @if (isAdmin === true) {
    <kendo-tilelayout-item
      [col]="1"
      [colSpan]="2"
    >
      <kendo-tilelayout-item-header class="org-details-header d-flex justify-content-between align-items-center">
        <h4>Account Mappings</h4>
        <div class="ms-auto">
          <button
            kendoButton
            class="details-edit-button"
            [id]="
              isReadOnlyAccountMappings()
                ? 'admin_organizations_general_accountmappings_edit'
                : 'admin_organizations_general_accountmappings_save'
            "
            (click)="onButtonClickAccountMappings()"
          >
            {{ isReadOnlyAccountMappings() ? 'Edit' : 'Save' }}
          </button>
        </div>
      </kendo-tilelayout-item-header>
      @if (isLoading()) {
        <kendo-loader
          [type]="'infinite-spinner'"
          [size]="'large'"
        ></kendo-loader>
      } @else {
        <kendo-tilelayout-item-body>
          <form
            class="k-form"
            [formGroup]="ckbForm()"
          >
            <div class="k-form-field">
              <div class="k-form-field-container two-column-form">
                <div class="k-form-field-wrap">
                  <label>Zoho Id</label>
                  <kendo-textbox formControlName="zoho_id"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Zoho Name</label>
                  <kendo-textbox formControlName="zoho_name"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Stellar Cyber Id</label>
                  <kendo-textbox formControlName="stellar_cyber_id"></kendo-textbox>
                  <div class="k-form-hint">Synced with Integrations &gt; Mappings. A conflicting id is rejected.</div>
                  @if (ckbForm().get('stellar_cyber_id')?.errors?.['server']; as error) {
                    <div class="k-form-error">{{ error }}</div>
                  }
                </div>
                <div class="k-form-field-wrap">
                  <label>Stellar Cyber Name</label>
                  <kendo-textbox formControlName="stellar_cyber_name"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Sentinel One Id</label>
                  <kendo-textbox formControlName="sentinel_one_id"></kendo-textbox>
                  <div class="k-form-hint">Synced with Integrations &gt; Mappings. A conflicting id is rejected.</div>
                  @if (ckbForm().get('sentinel_one_id')?.errors?.['server']; as error) {
                    <div class="k-form-error">{{ error }}</div>
                  }
                </div>
                <div class="k-form-field-wrap">
                  <label>Sentinel One Name</label>
                  <kendo-textbox formControlName="sentinel_one_name"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Cyrisma Id</label>
                  <kendo-textbox formControlName="cyrisma_id"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Cyrisma Name</label>
                  <kendo-textbox formControlName="cyrisma_name"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Chronicle Id</label>
                  <kendo-textbox formControlName="chronicle_id"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Chronicle Name</label>
                  <kendo-textbox formControlName="chronicle_name"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>XRAI Id</label>
                  <kendo-textbox formControlName="xrai_id"></kendo-textbox>
                  @if (ckbForm().get('xrai_id')?.errors?.['server']; as error) {
                    <div class="k-form-error">{{ error }}</div>
                  }
                </div>
                <div class="k-form-field-wrap">
                  <label>XRAI Name</label>
                  <kendo-textbox formControlName="xrai_name"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Assure Id</label>
                  <kendo-textbox formControlName="assure_id"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Assure Name</label>
                  <kendo-textbox formControlName="assure_name"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Polymer Id</label>
                  <kendo-textbox formControlName="polymer_id"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Polymer Name</label>
                  <kendo-textbox formControlName="polymer_name"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Checkpoint Id</label>
                  <kendo-textbox formControlName="checkpoint_id"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Checkpoint Name</label>
                  <kendo-textbox formControlName="checkpoint_name"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Crowdstrike EDR Id</label>
                  <kendo-textbox formControlName="crowdstrike_edr_id"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Crowdstrike EDR Name</label>
                  <kendo-textbox formControlName="crowdstrike_edr_name"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Crowdstrike XDR Id</label>
                  <kendo-textbox formControlName="crowdstrike_xdr_id"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Crowdstrike XDR Name</label>
                  <kendo-textbox formControlName="crowdstrike_xdr_name"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Vicarius Id</label>
                  <kendo-textbox formControlName="vicarius_id"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Vicarius Name</label>
                  <kendo-textbox formControlName="vicarius_name"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Zenskar Id</label>
                  <kendo-textbox formControlName="zenskar_id"></kendo-textbox>
                </div>
                <div class="k-form-field-wrap">
                  <label>Zenskar Name</label>
                  <kendo-textbox formControlName="zenskar_name"></kendo-textbox>
                </div>
              </div>
            </div>
          </form>
        </kendo-tilelayout-item-body>
      }
    </kendo-tilelayout-item>
  } @else {}
</kendo-tilelayout>
